export class User {
    _id: string;
    firstName: string;
    lastName: string;
    login: string;
    roles: string[];
}
